export const selectedOffersSchema = {
  'offer_name': {
    name: 'Offer Name',
    type: 'string',
    fn: []
  },
  'items': {
    name: 'Items',
    type: 'string',
    fn: []
  },
  'avg_sales_per_store_week': {
    name: 'AVERAGE SALES PER STORE PER WEEK ($)',
    type: 'number',
    fn: ['formatAsMoney']
  },
  'print': {
    name: 'PRINT',
    type: 'string',
    fn: []
  },
  'display': {
    name: 'DISPLAY',
    type: 'string',
    fn: []
  },
  'est_sales_qty_during_promo_lift': {
    name: 'Estimated SALES QTY DURING PROMO AND (LIFT %)',
    type: 'string',
    fn: []
  },
  'est_sales_dollars_during_promo': {
    name: 'Estimated SALES $ DURING PROMO',
    type: 'number',
    fn: ['formatAsMoney']
  },
  'est_retail_savings_during_promo': {
    name: 'Estimated RETAIL SAVINGS $ DURING PROMO',
    type: 'number',
    fn: ['formatAsMoney']
  },
  'est_psp_funding': {
    name: 'Estimated PSP FUNDING $ (%)',
    type: 'number',
    fn: ['formatAsMoney']
  },
  'est_vendor_funding': {
    name: 'Estimated VENDOR FUNDING $ (%)',
    type: 'number',
    fn: ['formatAsMoney']
  },
  'total_est_unit_sales_lift': {
    name: 'TOTAL Estimated Unit Sales lift required for margin neutrality (POS)',
    type: 'string',
    fn: ['formatAsPercentage']
  },
  'total_est_margin_gain': {
    name: 'TOTAL Estimated MARGIN $ GAIN (POS)',
    type: 'number',
    fn: ['formatAsMoney']
  },
  'total_est_margin_lift': {
    name: 'TOTAL Estimated MARGIN LIFT (POS)',
    type: 'number',
    fn: ['formatAsPercentage']
  },
  'est_direct_lift': {
    name: 'Estimated DIRECT LIFT (POS)',
    type: 'number',
    fn: ['formatAsPercentage']
  },
  'est_halo_lift': {
    name: 'Estimated HALO LIFT (POS)',
    type: 'number',
    fn: ['formatAsPercentage']
  },
  'est_affinity_pull_lift': {
    name: 'Estimated AFFINITY PULL LIFT (POS)',
    type: 'number',
    fn: ['formatAsPercentage']
  },
  'est_cannibalization_loss': {
    name: 'Estimated CANNIBALIZATION LOSS (POS)',
    type: 'number',
    fn: ['formatAsPercentage']
  },
  'est_pull_forward_loss': {
    name: 'Estimated PULL-FORWARD LOSS (POS)',
    type: 'number',
    fn: ['formatAsPercentage']
  }
}



// WEBPACK FOOTER //
// ./src/components/selected-offers-list/selectedOffersSchema.js